import { useHookstate } from "@hookstate/core";
import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import { CarDetails } from "commonComponents/CarDetails";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";

const CarDetailsOnCarIcon = () => {
  const style4 = {
    position: "fixed",
    maxWidth: "420px",
    width: "100%",
    bgcolor: "#ffffff",
    bottom: "0",
    right: "0",
    height: "100%",
    border: "0 solid #000",
  };

  const { showCarDetails, clickWindowState, carForPopup } = useHookstate(MAP_GLOBAL_STATES);

  const handleClose4 = () => {
    showCarDetails.set(false);
    clickWindowState.set(false);
  };

  return (
    <Modal
      open={showCarDetails.get()}
      onClose={handleClose4}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style4}>
        <CarDetails carInformation={carForPopup.get()} handleClick={handleClose4} />
      </Box>
    </Modal>
  );
};

export default CarDetailsOnCarIcon;
